import { FincasPlataformaService } from "../../generated/grpc/plataforma_terceros_fincas_pb";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** SAS de subida a Azure Blob (`FincasPlataformaService.GetSasSubida`, gRPC). */
class StorageSubidaService {
  /** `sasUrl` para el PUT directo a Azure y `blobUrl` permanente que luego se manda al servidor. */
  async getSasSubida(fileName: string): Promise<{ sasUrl: string; blobUrl: string }> {
    const r = await grpcCall(() => grpcClient(FincasPlataformaService).getSasSubida({ fileName }));
    return { sasUrl: r.sasUrl, blobUrl: r.blobUrl };
  }
}

/** Singleton del servicio de SAS de subida. */
export const storageSubidaService = new StorageSubidaService();
